/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it


// 👉 Import Google Fonts - @fontsource
import "@fontsource/barlow/300.css";
import "@fontsource/barlow/400.css";
import "@fontsource/barlow/500.css";
import "@fontsource/barlow/600.css";
import "@fontsource/barlow/700.css";
import "@fontsource/barlow/900.css";

import "@fontsource/barlow-condensed/300.css";
import "@fontsource/barlow-condensed/400.css";
import "@fontsource/barlow-condensed/500.css";
import "@fontsource/barlow-condensed/600.css";
import "@fontsource/barlow-condensed/700.css";
import "@fontsource/barlow-condensed/900.css";


const shouldUpdateScroll = args => {
  return false;
};

let scrollState = {
  thresholds: [25, 50, 75, 100],
  fired: new Set(),
  currentPath: ''
};

const handleScroll = () => {
  const scrollPercent = Math.round(
    (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100
  );

  scrollState.thresholds.forEach(threshold => {
    const key = `${scrollState.currentPath}-${threshold}`;
    if (scrollPercent >= threshold && !scrollState.fired.has(key)) {
      scrollState.fired.add(key);
      
      window.dataLayer = window.dataLayer || [];

      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'gtm.scrollDepth',
          gtm: { scrollThreshold: threshold },
          page_path: scrollState.currentPath
        });
      }
    }
  });
};

// Execute this function when the route changes
const onRouteUpdate = ({ location, prevLocation }) => {
  // Mapping of old relative paths to new relative paths
  setTimeout(() => {
    if (typeof window !== `undefined`) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, 200);

  scrollState.currentPath = location.pathname;
  
  if (prevLocation !== null) {
    // Route change event
    window.dataLayer = window.dataLayer || [];
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'gtm.scrollDepth',
        page_path: location.pathname + location.search,
      });
    }
  }
  
  // Add scroll listener
  window.addEventListener('scroll', handleScroll, { passive: true });

  const pathRedirects = {
    "/ism/resources/": "/ism/resources/access-support/",
    "/ism/resources/access-and-support/": "/ism/resources/access-support/",
    "/ism/resources/faq/": "/ism/resources/faqs/",
    "/ism/#sign-up": "/ism/connect-with-us/"
  };

  // Get the current path including hash
  const currentPath = location.pathname + location.hash;

  // Check if the current path matches any of the old relative paths
  if (pathRedirects[currentPath]) {
    // Redirect to the new relative path
    window.location.pathname = pathRedirects[currentPath];
  }
};

export {
  shouldUpdateScroll,
  onRouteUpdate
}